import { Dialog, Grid, Button, DialogActions } from '@mui/material';
import { Typography } from '@uhc-tempo/components';
import { useContext } from 'react';
import { FormContext } from '../../../context/Form.context';
import { PRIOR_AUTH_IDS, PRIOR_AUTH_DIALOG_TEXT } from '../../../constants';
export default function PriorAuthDialog(props) {
    const { showPriorAuthModel, handleCloseDialog } = props;
    const priorAuthStyles = {
        temp: {
            paddingTop: '16px',
            paddingRight: '24px',
            paddingLeft: '24px',
        },
    };
    const singleEstimateResponse = useContext(FormContext);
    const claims = singleEstimateResponse?.singleEstimateResponse?.claims;
    const procedureDetails = claims?.[0]?.procedures?.[0];
    const facilityName =
        claims?.[0]?.procedures?.[0]?.provider?.organizationName ||
        claims?.[1]?.procedures?.[0]?.provider?.organizationName;

    const personName = procedureDetails?.provider?.personName;
    // Retrieve serviceNotes from the singleEstimateResponse
    const serviceNotes = singleEstimateResponse?.estimateResponse?.scenarios?.[0]?.serviceNotes;
    const targetPriorAuthIds = [
        PRIOR_AUTH_IDS.Member_SingleBillingCode,
        PRIOR_AUTH_IDS.Provider_SingleBillingCode_ASO,
        PRIOR_AUTH_IDS.SiteOfService_SingleBillingCode,
        PRIOR_AUTH_IDS.Provider_SingleBillingCode,
    ];
    const matchedServiceNote =
        serviceNotes?.find((serviceNote) => targetPriorAuthIds.includes(serviceNote.id)) || null;

    // Based on the prior auth id's like ('A', 'V', 'X', 'T') display the different paragraphs in the dialog
    const modalMessageLookup = {
        [PRIOR_AUTH_IDS.Member_SingleBillingCode]: [
            PRIOR_AUTH_DIALOG_TEXT.Member_Provider_PriorAuth_Para1_Shared_Text,
            PRIOR_AUTH_DIALOG_TEXT.Member_Provider_PriorAuth_Para2_Shared_Text,
            PRIOR_AUTH_DIALOG_TEXT.Member_PriorAuth_Text,
        ],

        [PRIOR_AUTH_IDS.Provider_SingleBillingCode]: [
            PRIOR_AUTH_DIALOG_TEXT.Member_Provider_PriorAuth_Para1_Shared_Text,
            PRIOR_AUTH_DIALOG_TEXT.Member_Provider_PriorAuth_Para2_Shared_Text,
            PRIOR_AUTH_DIALOG_TEXT.Provider_PriorAuth_Para3_Shared_Text,
        ],

        [PRIOR_AUTH_IDS.Provider_SingleBillingCode_ASO]: [
            PRIOR_AUTH_DIALOG_TEXT.Member_Provider_PriorAuth_Para1_Shared_Text,
            PRIOR_AUTH_DIALOG_TEXT.Member_Provider_PriorAuth_Para2_Shared_Text,
            PRIOR_AUTH_DIALOG_TEXT.Provider_PriorAuth_Para3_Shared_Text,
        ],

        [PRIOR_AUTH_IDS.SiteOfService_SingleBillingCode]: [
            PRIOR_AUTH_DIALOG_TEXT.Member_Provider_PriorAuth_Para1_Shared_Text,
            PRIOR_AUTH_DIALOG_TEXT.Member_Provider_PriorAuth_Para2_Shared_Text,
            PRIOR_AUTH_DIALOG_TEXT.Provider_PriorAuth_Para3_Shared_Text,
            PRIOR_AUTH_DIALOG_TEXT.Provider_PriorAuth_MultipleSitesOfService_Text,
        ],
    };

    const modalContentParagraphs = modalMessageLookup[matchedServiceNote?.id] || [];

    return (
        <>
            <Dialog
                open={showPriorAuthModel}
                onClose={handleCloseDialog}
                data-testid="priorAuth-popup"
                maxWidth={'md'}
                fullWidth={true}
                id="priorAuth-dialog"
                PaperProps={{
                    tabIndex: -1,
                    id: 'priorAuthDialogChildDiv',
                    style: { overflowY: 'auto' },
                    'aria-labelledby': 'priorAuthH2',
                }}
            >
                <Grid>
                    <Grid container direction="column" style={{ paddingBottom: '24px' }}>
                        <button
                            className="tds-modal__close"
                            aria-label="close PriorAuth Dialog"
                            onClick={handleCloseDialog}
                            style={{ float: 'right' }}
                        >
                            <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                role="presentation"
                                className="tds-modal__close--icon"
                            >
                                <title>Done</title>
                                <defs>
                                    <rect
                                        id="modal_000_close"
                                        x="0"
                                        y="0"
                                        width="14"
                                        height="14"
                                        rx="8"
                                    ></rect>
                                </defs>
                                <g fill="none" fillRule="evenodd">
                                    <path
                                        d="M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z"
                                        fill="#196ECF"
                                    ></path>
                                </g>
                            </svg>
                        </button>
                    </Grid>
                    <Grid item xs={12}>
                        <div id="dialogHeader">
                            <Grid item xs={12}>
                                <Typography.H2 id="priorAuthH2" style={priorAuthStyles.temp}>
                                    {'About prior authorization'}
                                </Typography.H2>
                            </Grid>
                        </div>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        style={{
                            paddingTop: '4px',
                            paddingRight: '24px',
                            paddingLeft: '24px',
                        }}
                    >
                        {modalContentParagraphs.length > 0 &&
                            modalContentParagraphs.map((paragraph, index) => (
                                <Typography.Paragraph
                                    key={index}
                                    data-testid="priorAuthDialogMessageNew"
                                >
                                    <div>{paragraph}</div>
                                </Typography.Paragraph>
                            ))}

                        <Typography.Paragraph data-testid="priorAuthDialogMessage">
                            {((matchedServiceNote != null &&
                                matchedServiceNote?.id ===
                                    PRIOR_AUTH_IDS.Provider_SingleBillingCode) ||
                                matchedServiceNote?.id ===
                                    PRIOR_AUTH_IDS.Member_SingleBillingCode) && (
                                <div
                                    style={{
                                        fontFamily: '"UHC Sans", Arial, sans-serif',
                                        fontStyle: 'Normal',
                                        fontSize: '16px',
                                        lineHeight: '24px',
                                        fontWeight: 700,
                                        color: '#333333',
                                    }}
                                >
                                    <b>
                                        {singleEstimateResponse?.estimateResponse?.carePath?.name}
                                    </b>
                                    <br />
                                    <div style={{ paddingLeft: '16px' }}>
                                        <b>CPT code:</b>
                                        <br />
                                        <span style={{ fontWeight: 'normal' }}>
                                            {procedureDetails?.procedureCode?.code}
                                        </span>
                                        <br />
                                        <b>Place of service:</b>
                                        <br />
                                        <span style={{ fontWeight: 'normal' }}>
                                            {procedureDetails?.placeOfServiceCode
                                                ? procedureDetails.placeOfServiceCode
                                                : 'Not Available'}
                                        </span>
                                        {facilityName && (
                                            <>
                                                <br />
                                                <b>Facility name:</b>
                                                <br />
                                                <span style={{ fontWeight: 'normal' }}>
                                                    {facilityName}{' '}
                                                </span>
                                            </>
                                        )}
                                        {personName && Object.keys(personName).length > 0 && (
                                            <>
                                                <br />
                                                <b>Physician:</b>
                                                <br />
                                                <span style={{ fontWeight: 'normal' }}>
                                                    {personName?.firstName} {personName?.lastName}
                                                </span>
                                            </>
                                        )}
                                    </div>
                                </div>
                            )}
                        </Typography.Paragraph>
                    </Grid>
                    <DialogActions
                        aria-label="priorAuthModel"
                        style={{
                            paddingTop: '16px',
                            paddingLeft: '24px',
                            paddingRight: '24px',
                            paddingBottom: '16px',
                            float: 'right',
                        }}
                    >
                        <Grid container alignItems="center" justify="flext-start">
                            <Grid>
                                <Button
                                    aria-label="priorAuth modal close button"
                                    variant="contained"
                                    color="primary"
                                    onClick={handleCloseDialog}
                                    style={{
                                        borderRadius: '26px',
                                        backgroundColor: '#002677',
                                        textTransform: 'none',
                                    }}
                                >
                                    Done
                                </Button>
                            </Grid>
                        </Grid>
                    </DialogActions>
                </Grid>
            </Dialog>
        </>
    );
}
